module.exports = __webpack_public_path__ + "static/media/tour-reward.42b4a9dc.svg";